<template>
	<div class="view-content">
		<div class="view-content-info">
			<div class="user-login" v-if="show">
				<div class="user-login-title"><span>我的购物车</span></div>
				
				
				<div class="ordergoods-table user-login-content" v-if="normalList.length > 0 || loseList.length > 0">
					<div class="ordergoods-table-title flex-center flex-between">
						<div class="ordergoods-table-title-select flex-center flex-start" @click="selectAll">
							<img v-if="info.totalNum == info.selectedNum" src="@/assets/images/radio.png"/>
							<img v-else src="@/assets/images/no-radio.png"/>
							全选
						</div>
						<div class="ordergoods-table-title-title">商品信息</div>
						<div class="ordergoods-table-title-price">单价</div>
						<div class="ordergoods-table-title-price">数量</div>
						<div class="ordergoods-table-title-price">小计</div>
						<div class="ordergoods-table-title-price">操作</div>
					</div>
					<div class="ordergoods-table-body">
						<div v-for="item in normalList" :key="item.id" class="ordergoods-table-item flex-between flex-center">
							<div class="ordergoods-table-item-select flex-center flex-start" @click.stop="changeSelect(item.id, item.selectedStatus?0:1)">
								<img v-if="item.selectedStatus == 0" src="@/assets/images/radio.png"/>
								<img v-else src="@/assets/images/no-radio.png"/>
							</div>
							
							<div class="ordergoods-table-item-goods flex-start flex-center">
								<img class="ordergoods-table-item-goods-image" @click="toInfo(item.goodsId)" :src="item.listImage.split(',')[0]" mode="aspectFill"></img>
								<div class="ordergoods-table-item-goods-text" @click="toInfo(item.goodsId)">
									<div>{{item.goodsName}}</div>
									<div>{{item.parentName?item.parentName:''}}{{item.goodsSpecName}}</div>
								</div>
								<div class="ordergoods-table-item-price">￥{{item.presentPrice}}</div>
								<div class="ordergoods-table-item-stock flex-center flex-midden">
									<i v-if="item.goodsNum > 1 && item.goodsNum > item.minOrderNum" @click.stop="changeNum(item,2)" style="font-size: 30px;color: #000;" class="el-icon-remove-outline"></i>
									<i v-else class="el-icon-remove-outline" :title="'最少购买'+item.minOrderNum+'件'" style="font-size: 30px;color: rgb(144, 147, 153);"></i>
									<el-input-number style="width: 100px;" v-model="item.goodsNum" @blur="changeNowNum(item)" :controls="false" label="请输入购买数量"></el-input-number>
									<i v-if="item.goodsNum < item.stockNum" @click.stop="changeNum(item,1)" style="font-size: 30px;color: #000;" class="el-icon-circle-plus-outline"></i>
									<i v-else class="el-icon-circle-plus-outline" style="font-size: 30px;color: rgb(144, 147, 153);"></i>
								</div> 
								<div class="ordergoods-table-item-value">￥{{item.totalPrice}}</div> 
								<div class="ordergoods-table-item-value" @click.stop="deleteGoods(item.id)">删除</div> 
							</div>
						</div>
					</div>
					
					<div class="ordergoods-table-name" v-if="loseList.length > 0">失效商品</div>
					
					<div class="ordergoods-table-body">
						<div v-for="item in loseList" :key="item.id" class="ordergoods-table-item flex-between flex-center">
							<div class="ordergoods-table-item-select flex-center flex-start" @click.stop="changeSelect(item.id, item.selectedStatus?0:1)">
								<img v-if="item.selectedStatus == 0" src="@/assets/images/radio.png"/>
								<img v-else src="@/assets/images/no-radio.png"/>
							</div>
							
							<div class="ordergoods-table-item-goods flex-start flex-center">
								<img class="ordergoods-table-item-goods-image" :src="item.listImage.split(',')[0]" mode="aspectFill"></img>
								<div class="ordergoods-table-item-goods-text">
									<div>{{item.goodsName}}</div>
									<div>{{item.parentName?item.parentName:''}}{{item.goodsSpecName}}</div>
								</div>
								<div class="ordergoods-table-item-price" style="color: rgba(7, 11, 19, 0.4);">￥{{item.presentPrice}}</div>
								<div class="ordergoods-table-item-stock flex-center flex-midden">
									<div>{{item.goodsNum}}</div>
								</div> 
								<div class="ordergoods-table-item-value" style="color: rgba(7, 11, 19, 0.4);">￥{{item.totalPrice}}</div> 
								<div class="ordergoods-table-item-value" @click.stop="deleteGoods(item.id)">删除</div> 
							</div>
						</div>
					</div>
				</div>
				
				
				<div class="cart-bottom-content"  v-if="normalList.length > 0 || loseList.length > 0">
					<div class="cart-bottom flex-between flex-center">
						
						<div class="cart-bottom-left flex-start flex-center">
							<div class="cart-bottom-left-select flex-start flex-center" @click="selectAll">
								<img v-if="info.totalNum == info.selectedNum" src="@/assets/images/radio.png"/>
								<img v-else src="@/assets/images/no-radio.png"/>
								全选
							</div>
							<div class="cart-bottom-left-remove" @click="deleteallGoods">删除选中商品</div>
						</div>
						
						<div class="cart-bottom-right flex-end flex-center">
							<div class="cart-bottom-right-text">
								共 <span>{{info.totalNum}}</span> 件商品，已选择 <span>{{info.selectedNum}}</span> 件    |    订单合计: ¥{{info.totalPrice}}    |    应付总额: <span>¥{{info.totalPrice}}</span>
							</div>
							<div class="cart-bottom-right-button" @click="toSubmit">下单结算</div>
						</div>
					</div>
				</div>
				
				
				<div class="no-data" v-if="normalList.length == 0 && loseList.length == 0 && show == true">
					<img src="@/assets/images/cart-no.png"/>
					<div>对不起，对应商品分类或筛选组合下没有商品</div>
					
					<div class="no-data-button" @click="toIndex">继续逛逛</div>
				</div>
				
				
			</div>
		</div>
	</div>
</template>

<script>
	import {getShoppingCartList,updateShoppingCartNum,deleteShoppingCart,updateShoppingCartSelected} from "@/api/user"
	export default {
		data(){
			return {
				normalList:[],
				loseList:[],
				info:{},
				show:false
			}
		},
		mounted() {
			this.getList();
		},
		methods:{
			getList(){
				getShoppingCartList().then(res=>{
					if(res.code == 1000){
						this.normalList = res.data.normalList;
						this.loseList = res.data.loseList;
						this.info = res.data;
						this.show = true;
					}else{
						return this.$message.error(res.message);
					}
				})
			},
			//改变数量
			changeNum(info, action){
				if(action == 1){//增加数字
					updateShoppingCartNum({
						cartId:info.id,
						num:info.goodsNum+1
					}).then(res=>{
						if(res.code == 1000){
							this.getList();
						}else{
							return this.$message.error(res.message);
						}
					})
				}else if(action == 2){//减少数字
					if(info.goodsNum > 1){
						updateShoppingCartNum({
							cartId:info.id,
							num:info.goodsNum-1
						}).then(res=>{
							if(res.code == 1000){
								this.getList();
							}else{
								return this.$message.error(res.message);
							}
						})
					}
				}
			},
			changeNowNum(info){
				let value = info.goodsNum;
				if(value >= info.stockNum){
					value = info.stockNum;
					this.$message.error("库存不足");
				}
				if(value <= info.minOrderNum){
					value = info.minOrderNum;
					this.$message.error("最小起订量为"+info.minOrderNum);
				}
				if(value < 1){
					value = 1;
				}
				updateShoppingCartNum({
					cartId:info.id,
					num:value
				}).then(res=>{
					if(res.code == 1000){
						this.getList();
					}else{
						return this.$message.error(res.message);
					}
				})
			},
			//删除单个购物车的商品
			deleteGoods(id){
				
				this.$alert('确定要删除商品吗？', '提示', {
					confirmButtonText: '确定',
					showCancelButton:true,
					callback: action => {
						if(action  == "confirm"){
							deleteShoppingCart([id]).then(res=>{
								if(res.code == 1000){
									this.getList();
									this.$store.dispatch('fetchCartNum');
								}else{
									return this.$message.error(res.message);
								}
							})
						}
					}
				});
				
			},
			//调整选中状态
			changeSelect(id,status){
				updateShoppingCartSelected({
					cartIds:[id],
					selected:status
				}).then(res=>{
					if(res.code == 1000){
						this.getList();
					}else{
						return this.$message.error(res.message);
					}
				})
			},
			//全选或者取消全选
			selectAll(){
				let ids = [];
				this.normalList.map(item=>{
					ids.push(item.id);
				})
				this.loseList.map(item=>{
					ids.push(item.id);
				})
				if(ids.length == 0){
					return false;
				}
				updateShoppingCartSelected({
					cartIds:ids,
					selected:this.info.selectedNum == this.info.totalNum?1:0
				}).then(res=>{
					if(res.code == 1000){
						this.getList();
					}else{
						return this.$message.error(res.message);
					}
				})
			},
			toInfo(id){
				window.open("/goodsinfo?id="+id);
			},
			toIndex(){
				this.$router.push("/");
			},
			deleteallGoods(){
				let ids = [];
				this.normalList.map(item=>{
					if(item.selectedStatus == 0){
						ids.push(item.id);
					}
				})
				this.loseList.map(item=>{
					if(item.selectedStatus == 0){
						ids.push(item.id);
					}
				})
				if(ids.length == 0){
					return false;
				}
				this.$alert('确定要删除选中商品吗？', '提示', {
					confirmButtonText: '确定',
					showCancelButton:true,
					callback: action => {
						if(action  == "confirm"){
							deleteShoppingCart(ids).then(res=>{
								if(res.code == 1000){
									this.getList();
									this.$store.dispatch('fetchCartNum');
								}else{
									return this.$message.error(res.message);
								}
							})
						}
					}
				});
				
			},
			toSubmit(){
				let ids = [];
				this.normalList.map(item=>{
					if(item.selectedStatus == 0){
						ids.push(item.id);
					}
				})
				if(ids.length == 0){
					return this.$message.error("请选择下单的商品");
				}
				this.$router.push("/submit?is_cart=0");
			}
		}
	}
</script>
<style scoped lang="scss">
	@import url("../assets/order.scss");
	.no-data{
		width: 100%;
		padding: calc(50vh - 400px) 0px;
		background: #FFFFFF;
		text-align: center;
		img{
			width: 120px;
			height: 120px;
		}
		div{
			font-size: 16px;
			font-weight: 500;
			color: #9E9E9E;
			margin-top: 12px;
		}
		.no-data-button{
			width: 180px;
			height: 48px;
			border: 1px solid #E91A12;
			font-size: 18px;
			line-height: 48px;
			color: #070B13;
			text-align: center;
			margin: 40px auto;
			cursor: pointer;
		}
	}
	.cart-bottom-right{
		.cart-bottom-right-text{
			font-size: 16px;
			color: #070B13;
			margin-right: 40px;
			span{
				color: #E91A12;
				&:last-of-type{
					font-size: 20px;
					margin-left: 12px;
				}
			}
		}
		.cart-bottom-right-button{
			width: 208px;
			height: 88px;
			background: #E91A12;
			font-size: 20px;
			font-weight: 500;
			line-height: 88px;
			text-align: center;
			color: #FFFFFF;
			cursor: pointer;
		}
	}
	.cart-bottom-content{
		background-color: #fff;
		padding: 30px 20px 40px;
		.cart-bottom{
			width: 1280px;
			height: 88px;
			background: #FEF6F6;
			.cart-bottom-left{
				padding-left: 40px;
				.cart-bottom-left-select{
					cursor: pointer;
					img{
						width: 20px;
						height: 20px;
						flex: 0 0 20px;
						margin-right: 12px;
					}
					div{
						font-size: 16px;
						font-weight: 500;
						line-height: 20px;
						color: #070B13;
					}
				}
				
				.cart-bottom-left-remove{
					cursor: pointer;
					font-size: 16px;
					font-weight: 500;
					line-height: 20px;
					color: #E91A12;
					margin-left: 12px;
				}
			}
		}
	}
</style>